const assignmentFilters = {
  userId: null,
  clientId: null,
  jobTitle: null,
  // Bound by AssignmentFilters.vue's Consultant Type dropdown, which was the only thing declaring it.
  // A field vuex-map-fields writes but the model never declared is not reactive in Vue 2 and is not
  // cleared by clearFilters, so Clear left it applied and a link into the list inherited it.
  employeeTypeId: null,
  active: null,
  includeInactive: null,
  overtimeEligible: null
}

export default () => Object.assign({}, assignmentFilters)
